import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { ConfirmDeclarerHasRestOfTricksDialogModel } from './confirm-declarer-has-rest-of-tricks-dialog.model'
import { PlayingGameService } from 'game-services'

@Component({
  selector: 'confirm-declarer-has-rest-of-tricks-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './confirm-declarer-has-rest-of-tricks-dialog.component.html',
  styleUrls: ['./confirm-declarer-has-rest-of-tricks-dialog.component.scss'],
})
export class ConfirmDeclarerHasRestOfTricksDialogComponent {
  public title = $localize`:ConfirmDeclarerHasRestOfTricksDialogComponent|Title:${this.model.declarerUsername}, claims they have the rest of the tricks.`
  public agreeLabel = $localize`:ConfirmDeclarerHasRestOfTricksDialogComponent|Agree label:Agree`
  public disagreeLabel = $localize`:ConfirmDeclarerHasRestOfTricksDialogComponent|Disagree label:Disagree`

  public constructor(
    private readonly dialogRef: MatDialogRef<ConfirmDeclarerHasRestOfTricksDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly model: ConfirmDeclarerHasRestOfTricksDialogModel,
    private readonly playingGameService: PlayingGameService,
  ) {}

  public async onRespond(hasAgreed: boolean): Promise<void> {
    await this.playingGameService.respondToDeclarerHasRestOfTricks(
      this.model.gamePlayGameId,
      hasAgreed,
    )

    this.dialogRef.close()
  }
}
